const SvgExpandMore = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
  >
    <path d="m16 19.057 7.529-7.528.943.943-8.471 8.471-8.472-8.471.943-.943 7.529 7.528z" />
  </svg>
);
export default SvgExpandMore;
